import { Flex, Group, Pill, Stack, Text } from '@mantine/core';

import { AwardValidationAction } from '@/module/Author/Award/Validation/AwardValidationAction';
import { AwardValidationHistory } from '@/module/Author/Award/Validation/AwardValidationHistory';
import { AwardDeleteButton } from '@/module/Author/Award/components/AwardDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { AwardProofAction } from './Proof';
import { Award } from './model/AwardTypes';

interface AwardViewProps {
  award: Award;
}

export function AwardView(props: AwardViewProps) {
  const { award } = props;
  const { title, awardedFor, year, type, contribution, institution, activity, conference, authors } = award;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{`${title} (${year})`}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <AwardDeleteButton awardId={award.id} />
            </Group>
          </Flex>
          {conference && <Text size="sm">{conference?.name}</Text>}
          <Group>
            <Pill>Pentru: {awardedFor?.name}</Pill>
            <Pill>Tip: {type?.name}</Pill>
            <Pill>Contribuție: {contribution?.name}</Pill>
            <Pill>Institutie: {institution?.name}</Pill>
            <Pill>Activitate: {activity?.name}</Pill>
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <AwardProofAction
        awardId={award.id}
        authors={authors}
      />
      <AwardValidationAction awardId={award.id} />
      <AwardValidationHistory awardId={award.id} />
    </Stack>
  );
}
